export default __webpack_public_path__ + "static/media/nr.8ccd0a5d.svg";